export default "__VITE_ASSET__cf55a2c4__"